import Vue from 'vue'
import { buildingTypeDisplayName } from '@/services/report/buildingTypes'
import { buildingStatusDisplayName } from '@/services/report/buildingStatus'
import { parseISO, isValid, format, parseJSON } from 'date-fns'

export function dateTransformator(value: any): string {
  const date = parseISO(value)
  if (isValid(date)) {
    return format(date, 'd.M.y')
  }

  const jsonDate = parseJSON(value)
  if (isValid(jsonDate)) {
    return format(jsonDate, 'd.M.y HH:mm')
  }

  return value
}

Vue.filter('formatDate', (val: any) => {
  return dateTransformator(val)
})

export const formatMoneyFilter = (num: number) =>
  num
    ? Math.round(num)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' Kč'
    : 'N/A'

export const formatMoneySquareFilter = (num: number) =>
  num
    ? Math.round(num)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' Kč/m²'
    : 'N/A'

export const formatMoneyRoundFilter = (num: number) =>
  num
    ? (Math.round(num / 1000) * 1000)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' Kč'
    : 'N/A'

Vue.filter('formatMoney', (num: number) => {
  return formatMoneyFilter(num)
})
Vue.filter('formatMoneyRound', (num: number) => {
  return formatMoneyRoundFilter(num)
})
Vue.filter('formatMoneySquare', (num: number) => {
  return formatMoneySquareFilter(num)
})

export const layoutFilter = (num: number) => {
  const no = Number(num)
  switch (no) {
    case 1:
      return 'do 41,99m² (1+)'
    case 2:
      return '42,00 – 66,99m² (2+)'
    case 3:
      return '67,00 – 86,99m² (3+)'
    case 4:
      return '87,00 – 121,99m² (4+)'
    case 5:
      return 'od 122,00 m² (5+)'
    default:
      return ''
  }
}

Vue.filter('layout', (num: number) => {
  return layoutFilter(num)
})

Vue.filter('buildingType', (val: string) => {
  const displayName = buildingTypeDisplayName(val)
  if (displayName.valid) {
    return displayName.value
  }

  return 'N/A'
})

Vue.filter('buildingStatus', (val: string) => {
  const displayName = buildingStatusDisplayName(val)
  if (displayName.valid) {
    return displayName.value
  }

  return 'N/A'
})

export function numberToFixed(val: any) {
  const num = Number(val)
  return isNaN(num) ? val : num.toFixed(2)
}

Vue.filter('numberToFixed', (val: any): number => {
  return numberToFixed(val)
})
